import { AvatarDropdown as CoreAvatarDropdown } from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  return (
    <CoreAvatarDropdown
      appId={BizAppConfig.appSsoClientId}
      tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      workbenchUrl={BizAppConfig.appWorkbenchUrl}
    />
  );
};

export default AvatarDropdown;
